import React, { useCallback, useEffect, useState } from "react";
import { Modal, Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isLoadingOfDeletion } from "../../../graphql/state";
import { ITEMS } from "../../../utils";
import { XLg } from "react-bootstrap-icons";

interface DeletePageFolderModalProps {
  itemType?: ITEMS;
  showDeleteModal: boolean;
  handleCloseModal: () => void;
  handleConfirmDelete: () => void;
  title: string;
  description: string;
  additionText?: string | undefined;
}

const DeletePageFolderModal: React.FC<DeletePageFolderModalProps> = ({
  itemType,
  showDeleteModal,
  handleCloseModal,
  handleConfirmDelete,
  title,
  description,
  additionText,
}) => {
  const { t } = useTranslation();

  const [deleteText, setDeleteText] = useState<string>(
    t("projects.deleteConfirm")
  );

  const handleResize = useCallback(() => {
    const screenWidth = window.innerWidth;
    setDeleteText(
      screenWidth > 768
        ? itemType === ITEMS.PAGE
          ? t("profile.deleteAction")
          : t("projects.deleteConfirm")
        : t("profile.deleteAction")
    );
  }, [t, itemType]);

  useEffect(() => {
    handleResize();
  }, [handleResize]);

  window.addEventListener("resize", handleResize);

  const tryDelete = () => {
    isLoadingOfDeletion(true);
    handleConfirmDelete();
    handleCloseModal();
  };

  return (
    <Modal
      show={showDeleteModal}
      onHide={handleCloseModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="d-flex align-items-center justify-content-between border-0">
        <Modal.Title className="fs-3">{title}</Modal.Title>

        <XLg
          size={24}
          role="button"
          onClick={handleCloseModal}
          className="ms-auto text-dark-gray"
        />
      </Modal.Header>
      <div className="p-md-3">
        <p className="fs-6 text-center px-3 px-md-2 m-0 text-gray">
          {description}
        </p>
        {additionText && (
          <p className="fs-6 text-center mb-0 px-3 text-gray">{additionText}</p>
        )}
      </div>
      <div className="modalMobileBtns d-flex align-items-center justify-content-between gx-md-2">
        <Col className="modalMobileBtn" md={5}>
          <Button
            variant="outline-dark"
            onClick={handleCloseModal}
            className="w-100 fw-normal dark-hover fs-6"
          >
            {t("profile.cancel")}
          </Button>
        </Col>
        <Col className="modalMobileBtn" md={5}>
          <Button
            variant="danger"
            className="w-100 text-white fs-6"
            onClick={() => tryDelete()}
          >
            {deleteText}
          </Button>
        </Col>
      </div>
    </Modal>
  );
};

export default DeletePageFolderModal;
